<template>
  <div class="modal fade" id="modal_escola" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="fw-bolder">Cadastrar nova escola</h2>
          <div id="modal_cidade_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
              </svg>
            </span>
          </div>
        </div>
        <div class="modal-body scroll-y" id="modal_aluno_body">
          <form class="form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework m-0"
              novalidate="novalidate"
              @submit.prevent="submit">
            <form-body :loading="form.processing || loading" :form="form" :addClass="'p-5'">
              <div class="row">
                <div class="col-12">
                  <form-group label="Escola" required :is-invalid="model.errors.EscolaNome">
                    <input
                        class="form-control mb-2"
                        type="text"
                        placeholder="Nome da Escola"
                        v-model="model.EscolaNome"
                        @blur="model.clearErrors('EscolaNome')"
                        :class="{'is-invalid' : model.errors.EscolaNome}"
                        maxlength="120"
                    />
                  </form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col">
                  <form-group label="Cidade" required :is-invalid="model.errors.cidade_id">
                    <select class="form-select" data-control="select2"
                            data-dropdown-parent="#modal_escola" v-select2
                            data-placeholder="Selecione uma cidade"
                            v-model="model.cidade_id">
                      <option></option>
                      <option v-for="cidade in cidades" :value="cidade.id" >{{ cidade.nome }}</option>
                    </select>
                  </form-group>
                </div>

                <div class="col">
                  <form-group label="Tipo" required :is-invalid="model.errors.EscolaTipo">
                    <select class="form-select"
                            v-model="model.EscolaTipo"
                            @blur="model.clearErrors('EscolaTipo')"
                            :class="{'is-invalid' : model.errors.EscolaTipo}">
                      <option value="1">Municipal</option>
                      <option value="2">Estadual</option>
                      <option value="3">Federal</option>
                      <option value="4">Particular</option>
                    </select>
                  </form-group>
                </div>
              </div>
            </form-body>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";

export default {
  components: {
    FormGroup,
    FormBody
  },
  data: _ => ({
    model: {},
    loading: false,
    cidades: []
  }),

  setup() {
    const form = useForm({EscolaNome: null, EscolaTipo: null, cidade_id: null})

    return {form};
  },

  created() {
    this.model = this.form

    axios.get(this.route('app.core.cidades')).then(response => {
      this.cidades = response.data
    })
  },

  methods: {
    closeModal() {
      this.form.reset()
      this.loading = false

      document.getElementById('modal_cidade_close').click();
    },

    async submit() {
      this.loading = true

      await axios.post(this.route('app.core.escolas-store'), this.form).then(response => {
        this.$emit('success', response.data.id)
        this.closeModal()
        this.form.reset()
        this.loading = false
      }).catch(error => {
        this.loading = false

        Object.entries(error.response.data.errors).forEach(([key, value]) => {
          this.form.setError(key, `${value}`)
        })
      })
    },

    resetForm() {
      this.loading = false
      this.aluno = {}
      this.form.defaults({EscolaNome: null, EscolaTipo: null, cidade_id: null})
      this.form.reset()
      this.form.clearErrors()
    }
  },
}
</script>